import { Routes, Route, Navigate } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import Header from './components/Header'
import Footer from './components/Footer'
import FloatingActions from './components/FloatingActions'

import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import FestTyperPage from './pages/FestTyperPage'
import FirmafestPage from './pages/FirmafestPage'
import PrivatfestPage from './pages/PrivatfestPage'
import BryllupPage from './pages/BryllupPage'
import GalleriPage from './pages/GalleriPage'
import KontaktPage from './pages/KontaktPage'
import FaaEtTilbudPage from './pages/FaaEtTilbudPage'
import ForespoergselPage from './pages/ForespoergselPage'
import PrivatlivspolitikPage from './pages/PrivatlivspolitikPage'
import NotFoundPage from './pages/NotFoundPage'
import ForbiddenPage from './pages/ForbiddenPage'

export default function App() {
  return (
    <div className="flex flex-col min-h-screen bg-neutral-950 text-neutral-100 selection:bg-gold-400 selection:text-black">
      <ScrollToTop />
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/casperdj" element={<Navigate to="/" replace />} />
          <Route path="/om-os" element={<AboutPage />} />
          <Route path="/fest-typer" element={<FestTyperPage />} />
          <Route path="/firmafest" element={<FirmafestPage />} />
          <Route path="/privatfest" element={<PrivatfestPage />} />
          <Route path="/bryllup" element={<BryllupPage />} />
          <Route path="/galleri" element={<GalleriPage />} />
          <Route path="/kontakt" element={<KontaktPage />} />
          <Route path="/faa-et-tilbud" element={<FaaEtTilbudPage />} />
          <Route path="/foresprgsel" element={<ForespoergselPage />} />
          <Route path="/privatlivspolitik" element={<PrivatlivspolitikPage />} />
          <Route path="/privatliv" element={<Navigate to="/privatlivspolitik" replace />} />
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
      <FloatingActions />
    </div>
  )
}
